module.exports = __webpack_public_path__ + "static/media/Tactic.e5160393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tactic.png
// module id = 71
// module chunks = 0